import { type ObjectValuesUnionType } from '../../utils/typing';

export const RegulationActionTypes = Object.freeze({
  SET_REALITY_CHECK_MESSAGE: 'CORE:SET_REALITY_CHECK_MESSAGE',
  DISMISS_REALITY_CHECK_MESSAGE: 'CORE:DISMISS_REALITY_CHECK_MESSAGE',
});
export type RegulationActionType = ObjectValuesUnionType<typeof RegulationActionTypes>;
